(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("kqxko", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $43b2bc8dbb08d94f$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $5jxwZ = parcelRequire("5jxwZ");

var $exvWl = parcelRequire("exvWl");

var $l8eky = parcelRequire("l8eky");

var $515ZP = parcelRequire("515ZP");

const $43b2bc8dbb08d94f$var$FormCheckbox = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("a5g13")));

const $43b2bc8dbb08d94f$var$FormHidden = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("2AjeZ")));

const $43b2bc8dbb08d94f$var$FormServerError = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("imsPh")));

const $43b2bc8dbb08d94f$var$FormSubmitButton = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("iqcu3")));

const $43b2bc8dbb08d94f$var$FormInput = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("4ZL4c")));

const $43b2bc8dbb08d94f$var$FormWithSsnData = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("lNXdN")));
const $43b2bc8dbb08d94f$var$EvaluateResidenceForm = ({ customerId: customerId, headline: headline, text: text, sendButtonText: sendButtonText, successHeadline: successHeadline, successText: successText, leadsource: leadsource, officeName: officeName, officeId: officeId, regionId: regionId })=>{
    const form = (0, $exvWl.useForm)();
    const { isSubmitting: isSubmitting, isSubmitSuccessful: isSubmitSuccessful } = form.formState;
    const scrollElement = document.getElementById("evaluate-residence-form");
    const [selectedOfficeDropdown, setSelectedOfficeDropdown] = (0, $dTCkE.useState)();
    const [disableSubmit, setDisableSubmit] = (0, $dTCkE.useState)(false);
    (0, $dTCkE.useEffect)(()=>{
        if (!customerId && (!regionId || regionId !== "0")) setSelectedOfficeDropdown("LFF Huvudlicens");
    }, []);
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        id: "evaluate-residence-form",
        className: "flex overflow-y-auto overflow-x-hidden rounded-md py-10 px-3 xl:px-0",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: `${isSubmitSuccessful ? "translate-x-1.5/1- max-h-2/3 lg:max-h-screen/2" : ""} w-full flex-shrink-0 transform duration-300 mdplus:px-10 md:py-4`,
                children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                    className: " max-w-2xl mx-auto lg:pb-4",
                    children: [
                        /*#__PURE__*/ (0, $a9eYm.jsx)("h3", {
                            className: "text-blue700 text-center text-2xl md:text-2xl mb-4 lg:mb-6 lg:text-3xl",
                            children: headline || "V\xe4rdera bostad"
                        }),
                        text && /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                            className: "w-full lg:text-lg max-w-lg mx-auto text-center mb-4 mt-1- lg:mt-2-",
                            children: text
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                            children: /*#__PURE__*/ (0, $a9eYm.jsxs)($43b2bc8dbb08d94f$var$FormWithSsnData, {
                                form: form,
                                novalidate: true,
                                postUrl: (0, $515ZP.apiUrl) + "/api/Forms/EvaluateResidence",
                                setDisableSubmit: setDisableSubmit,
                                children: [
                                    /*#__PURE__*/ (0, $a9eYm.jsx)($43b2bc8dbb08d94f$var$FormInput, {
                                        placeholder: "E-postadress",
                                        label: "E-postadress*",
                                        name: "EmailAddress",
                                        type: "email",
                                        required: true,
                                        pattern: /^\S+@\S+\.\S+$/i
                                    }),
                                    /*#__PURE__*/ (0, $a9eYm.jsx)($43b2bc8dbb08d94f$var$FormInput, {
                                        placeholder: "Telefonnummer",
                                        label: "Telefonnummer*",
                                        name: "phone",
                                        type: "tel",
                                        pattern: /^(0|[+])([-\ ]?\d){7,12}$/i,
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $a9eYm.jsx)($43b2bc8dbb08d94f$var$FormHidden, {
                                        name: "LeadSourceId",
                                        value: leadsource || "CMLEADTYPE4R308GBP5JC0MHPO"
                                    }),
                                    customerId && !selectedOfficeDropdown && /*#__PURE__*/ (0, $a9eYm.jsx)($43b2bc8dbb08d94f$var$FormHidden, {
                                        name: "OfficeCustomerId",
                                        value: customerId
                                    }),
                                    !customerId && selectedOfficeDropdown && /*#__PURE__*/ (0, $a9eYm.jsx)($43b2bc8dbb08d94f$var$FormHidden, {
                                        name: "OfficeCustomerId",
                                        value: "S13777"
                                    }),
                                    officeId && /*#__PURE__*/ (0, $a9eYm.jsx)($43b2bc8dbb08d94f$var$FormHidden, {
                                        name: "OfficeId",
                                        value: officeId
                                    }),
                                    /*#__PURE__*/ (0, $a9eYm.jsx)($43b2bc8dbb08d94f$var$FormCheckbox, {
                                        label: "<span class='text-formatting'>Jag har l\xe4st och tagit del av <a target='_blank' href='/integritetspolicy\\'>integritetspolicyn</a>.</span>",
                                        name: "Gdpr",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $a9eYm.jsx)($43b2bc8dbb08d94f$var$FormSubmitButton, {
                                        text: sendButtonText || "Skicka",
                                        isLoading: isSubmitting,
                                        disabled: disableSubmit
                                    }),
                                    /*#__PURE__*/ (0, $a9eYm.jsx)($43b2bc8dbb08d94f$var$FormServerError, {
                                        formState: form.formState
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: `${isSubmitSuccessful ? "translate-x-1.5/1-" : ""} w-full flex-shrink-0 text-center transform duration-300 self-center ml-1/2`,
                children: /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $a9eYm.jsxs)("svg", {
                            className: `${isSubmitSuccessful ? "checkmarksign" : "checkmarksign"}`,
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 52 52",
                            children: [
                                /*#__PURE__*/ (0, $a9eYm.jsx)("circle", {
                                    className: "checkmarksign__circle",
                                    cx: "26",
                                    cy: "26",
                                    r: "25",
                                    fill: "none"
                                }),
                                /*#__PURE__*/ (0, $a9eYm.jsx)("path", {
                                    className: "checkmarksign__check",
                                    fill: "none",
                                    d: "M14.1 27.2l7.1 7.2 16.7-16.8"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                            className: "max-w-2xl mx-auto text-center",
                            children: [
                                /*#__PURE__*/ (0, $a9eYm.jsx)("h2", {
                                    className: "max-w-md mx-auto",
                                    children: /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                                        children: successHeadline || "Tack!"
                                    })
                                }),
                                /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                                    className: "max-w-md mx-auto",
                                    children: successText || "Vi \xe5terkopplar till dig s\xe5 snart vi kan."
                                })
                            ]
                        }),
                        isSubmitSuccessful && scrollElement && scrollElement.scrollIntoView({
                            behavior: "smooth"
                        }),
                        isSubmitSuccessful && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5jxwZ.HelmetProvider), {
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5jxwZ.Helmet), {
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)("script", {
                                    children: `
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'intresseformul\xe4r',
                            'eventInfo': {
                                'bobutik': '${officeName !== undefined ? officeName : ""}',
                                'intressetyp': 'V\xe4rderingsf\xf6rfr\xe5gan'
                                }
                        });

                        window.dataLayer.push({
                          'event': 'VirtualPageview',
                          'virtualPageURL': '${(0, $l8eky.gtmPageBuilder)(officeName !== undefined ? officeName : "")}',
                          'virtualPageTitle': '${(0, $l8eky.gtmPageBuilder)(officeName !== undefined ? officeName : "")}'
                      });
              `
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $43b2bc8dbb08d94f$export$2e2bcd8739ae039 = $43b2bc8dbb08d94f$var$EvaluateResidenceForm;

});
parcelRegister("515ZP", function(module, exports) {

$parcel$export(module.exports, "apiUrl", function () { return $faac5a7a58925656$export$e9ddf1da8d18d6f; });
$parcel$export(module.exports, "kycPortalUrl", function () { return $faac5a7a58925656$export$ad8fbf1335de6218; });
$parcel$export(module.exports, "getBrokerName", function () { return $faac5a7a58925656$export$8e6d207ebd320889; });
$parcel$export(module.exports, "getOfficeName", function () { return $faac5a7a58925656$export$e7fc2f87021c4f26; });
$parcel$export(module.exports, "getPersonalData", function () { return $faac5a7a58925656$export$35cd3e25af2ef930; });
$parcel$export(module.exports, "getMunicipalityTag", function () { return $faac5a7a58925656$export$930ee366b3d03280; });
$parcel$export(module.exports, "getCountyTag", function () { return $faac5a7a58925656$export$cebb9be7766a1779; });
$parcel$export(module.exports, "getQuestionListData", function () { return $faac5a7a58925656$export$f953ee8ad3c2f078; });
$parcel$export(module.exports, "getGeneralInfoData", function () { return $faac5a7a58925656$export$cfa44af66bbf621d; });
$parcel$export(module.exports, "getEconomyInfoData", function () { return $faac5a7a58925656$export$1c959a0887934c9; });
$parcel$export(module.exports, "getAboutEstateInfoData", function () { return $faac5a7a58925656$export$b4f8909e2e1b029f; });
$parcel$export(module.exports, "getHomeAssignmentDates", function () { return $faac5a7a58925656$export$c2f02f2cdcb26bb4; });
$parcel$export(module.exports, "getSurroundingInfoData", function () { return $faac5a7a58925656$export$c5edcf354e7951a6; });
$parcel$export(module.exports, "getTechnicalInfoData", function () { return $faac5a7a58925656$export$41378c6a48631b14; });
$parcel$export(module.exports, "getDeclarationBasisDates", function () { return $faac5a7a58925656$export$23160db3718428b9; });
$parcel$export(module.exports, "getDeclarationBasisSettlement", function () { return $faac5a7a58925656$export$5b598e839c07c5f4; });
$parcel$export(module.exports, "getDeclarationBasisSale", function () { return $faac5a7a58925656$export$e05d5ef9aa09290e; });
$parcel$export(module.exports, "getDeclarationBasisPurchase", function () { return $faac5a7a58925656$export$c7312eab72c6dcef; });
$parcel$export(module.exports, "getDeclarationBasisSuspension", function () { return $faac5a7a58925656$export$f9dd191eee96b121; });
$parcel$export(module.exports, "getDeclarationBasisMAR", function () { return $faac5a7a58925656$export$4905b08d33ae334f; });
$parcel$export(module.exports, "getToDoDates", function () { return $faac5a7a58925656$export$8da75b13c89971e6; });
$parcel$export(module.exports, "getKycForm", function () { return $faac5a7a58925656$export$ac86386cf209f951; });
$parcel$export(module.exports, "getWebsiteVisitor", function () { return $faac5a7a58925656$export$1f48879c04f44a0f; });
$parcel$export(module.exports, "getMunicipalityData", function () { return $faac5a7a58925656$export$9593ca3a476838b5; });
$parcel$export(module.exports, "getObjectTypeData", function () { return $faac5a7a58925656$export$64e4b188c77435e6; });
$parcel$export(module.exports, "getLoginInfo", function () { return $faac5a7a58925656$export$ebe451eb84baa5b8; });
$parcel$export(module.exports, "getGepositData", function () { return $faac5a7a58925656$export$cc20294e6e95aa8; });
$parcel$export(module.exports, "getNrOfSpeculators", function () { return $faac5a7a58925656$export$1c33aa1c52378f0; });
const $faac5a7a58925656$export$40edfb7eeb78c4e8 = true;
const $faac5a7a58925656$export$e9ddf1da8d18d6f = "https://app-lansfast-api.azurewebsites.net";
const $faac5a7a58925656$export$ad8fbf1335de6218 = "https://kyc.lansfast.se";
const $faac5a7a58925656$export$ad2637a4162a5855 = "http://localhost:5208";
const $faac5a7a58925656$export$90b486e772451dd = window.location.origin;
const $faac5a7a58925656$export$a1449de16bf292a7 = "/umbraco/api";
const $faac5a7a58925656$export$8e6d207ebd320889 = async (brokerId)=>{
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + `/api/Search/GetBrokerTag?brokerId=${brokerId}`);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$e7fc2f87021c4f26 = async (customerId)=>{
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + `/api/Search/GetOfficeTag?customerId=${customerId}`);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$35cd3e25af2ef930 = async (ssn)=>{
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + `/api/persondata/getpersoninformation?SSN=${ssn}`);
    const personalData = await response.json();
    return personalData;
};
const $faac5a7a58925656$export$930ee366b3d03280 = async (municipality)=>{
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + `/api/Search/CreateMunicipalityTags?municipality=${municipality}`);
    const data = await response.json();
    return data?.tag;
};
const $faac5a7a58925656$export$cebb9be7766a1779 = async (county)=>{
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + `/api/Search/CreateCountyTags?county=${county}`);
    const data = await response.json();
    return data?.tag;
};
const $faac5a7a58925656$export$f953ee8ad3c2f078 = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/GetQuestionList?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$cfa44af66bbf621d = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/HomeAssignment/GetGeneralInfo?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$1c959a0887934c9 = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/HomeAssignment/GetEconomyInfo?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$b4f8909e2e1b029f = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/HomeAssignment/GetAboutEstateInfo?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$c2f02f2cdcb26bb4 = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/HomeAssignment/GetDates?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$c5edcf354e7951a6 = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/HomeAssignment/GetSurroundingInfo?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$41378c6a48631b14 = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/HomeAssignment/GetTechnicalInfo?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$23160db3718428b9 = async (sessionId, estateId)=>{
    const GET_URL = `/api/MyPages/DeclarationBasis/GetDates?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$5b598e839c07c5f4 = async (sessionId, estateId)=>{
    const GET_URL = `/api/MyPages/DeclarationBasis/GetSettlement?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$e05d5ef9aa09290e = async (sessionId, estateId)=>{
    const GET_URL = `/api/MyPages/DeclarationBasis/GetSale?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$c7312eab72c6dcef = async (sessionId, estateId)=>{
    const GET_URL = `/api/MyPages/DeclarationBasis/GetPurchase?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$f9dd191eee96b121 = async (sessionId, estateId)=>{
    const GET_URL = `/api/MyPages/DeclarationBasis/GetSuspension?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$4905b08d33ae334f = async (sessionId, estateId)=>{
    const GET_URL = `/api/MyPages/DeclarationBasis/GetMaintenanceAndRebuilding?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$8da75b13c89971e6 = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/GetToDoDates?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$ac86386cf209f951 = async (userId, estateId)=>{
    const GET_URL = `/api/User/GetKycForms?` + new URLSearchParams({
        sessionId: userId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const data = await response.json();
    return data || null;
};
const $faac5a7a58925656$export$1f48879c04f44a0f = async (estateId, sessionId)=>{
    const GET_URL = `/api/Statistics/SourceData?` + new URLSearchParams({
        estateId: estateId,
        sessionId: sessionId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const objectWebsiteStats = await response.json();
    return objectWebsiteStats;
};
const $faac5a7a58925656$export$9593ca3a476838b5 = async (estateId, sessionId)=>{
    const GET_URL = `/api/Statistics/MunicipalityData?` + new URLSearchParams({
        estateId: estateId,
        sessionId: sessionId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const objectWebsiteStats = await response.json();
    return objectWebsiteStats;
};
const $faac5a7a58925656$export$64e4b188c77435e6 = async (estateId, sessionId)=>{
    const GET_URL = `/api/Statistics/ObjectTypeData?` + new URLSearchParams({
        estateId: estateId,
        sessionId: sessionId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const objectData = await response.json();
    return objectData;
};
const $faac5a7a58925656$export$ebe451eb84baa5b8 = async ()=>{
    const GET_URL = "/userapi/login";
    const response = await fetch($faac5a7a58925656$export$90b486e772451dd + $faac5a7a58925656$export$a1449de16bf292a7 + GET_URL);
    const loginInfo = await response.json();
    return loginInfo;
};
const $faac5a7a58925656$export$cc20294e6e95aa8 = async (query)=>{
    const GET_URL = `/api/Forms/GetGepositData?` + new URLSearchParams({
        query: query
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const specResult = await response.json();
    return specResult;
};
const $faac5a7a58925656$export$1c33aa1c52378f0 = async (data)=>{
    const POST_URL = `/api/Forms/SpeculatorCheck`;
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + POST_URL, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
    if (response.ok) {
        const specResult = await response.json();
        return specResult;
    } else data.setError("serverError", {
        type: "manual",
        message: response
    });
};

});

parcelRegister("a5g13", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7rgMa")).then(()=>parcelRequire("2gjUe"));

});

parcelRegister("2AjeZ", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("3H1xp")).then(()=>parcelRequire("7WMih"));

});

parcelRegister("imsPh", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("1WDNe")).then(()=>parcelRequire("jWc9o"));

});

parcelRegister("iqcu3", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("gg0Ro")).then(()=>parcelRequire("i4mAD"));

});

parcelRegister("4ZL4c", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("jc4ur"))
]).then(()=>parcelRequire("oPeBr"));

});

parcelRegister("lNXdN", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("bop5H")).then(()=>parcelRequire("48ipu"));

});


parcelRegister("1A7pc", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});

});

})();
//# sourceMappingURL=EvaluateResidenceForm.1ae0dc3c.js.map
